var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"l-navigationmain navigationmain",attrs:{"role":"navigation","aria-label":"navigation"}},[_c('ul',_vm._l((_vm.links),function(link,i){return _c('item-left-menu',{key:i + '-' + link.routeName,attrs:{"link":link}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }